import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import { baseURL } from './api/request'
Vue.config.productionTip = false
Vue.use(ElementUI);
// 将根请求路径注册一个变量 $baseURL
Vue.prototype.$baseURL = baseURL
//禁止用户F12、ctrl+shift+i、Shift+F10打开控制台
// document.onkeydown = () => {
//   //禁用F12
//   if (window.event && window.event.keyCode == 123) {
//     ElementUI.Message({
//       message: '此网站禁止打开控制台哦',
//       type: 'warning'
//     });
//     return false;
//     //禁用ctrl+shift+i,
//   } else if (window.event.ctrlKey && window.event.shiftKey && window.event.keyCode == 73) {
//     ElementUI.Message({
//       message: '此网站禁止打开控制台哦',
//       type: 'warning'
//     });
//     return false;
//     //屏蔽Shift+F10
//   } else if (window.event.shiftKey && window.event.keyCode == 121) {
//     ElementUI.Message({
//       message: '此网站禁止打开控制台哦',
//       type: 'warning'
//     });
//     return false;
//   }
// };
// 禁止用户右键打开控制台
// document.oncontextmenu = new Function("event.returnValue=false");

new Vue({
  // 使用路由
  router,
  // 使用Vuex
  store,
  render: h => h(App)
}).$mount('#app')
